
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.884 6.487h7.87m-7.87 0c0 1.283-1.057 2.322-2.36 2.322-1.305 0-2.362-1.04-2.362-2.322m4.722 0c0-1.282-1.057-2.321-2.36-2.321-1.305 0-2.362 1.04-2.362 2.321m0 0H2.588m7.87 6.19h-7.87m7.87 0c0-1.281 1.057-2.32 2.361-2.32 1.304 0 2.361 1.039 2.361 2.32m-4.722 0c0 1.283 1.057 2.322 2.361 2.322 1.304 0 2.361-1.039 2.361-2.321m0 0h1.575","stroke":"#C7CBCF","stroke-width":"1.8","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    